export interface ForsyningIndstillinger {
    forsyningNodeId: number;
    forsyningId: string;
    forsyningNavn: string;
    eforsyningUrl: string;
    appServerUrl: string;
    sideId: string;
}
